import { render, staticRenderFns } from "./IndexSelection.vue?vue&type=template&id=775b2bdc&scoped=true"
import script from "./IndexSelection.vue?vue&type=script&lang=js"
export * from "./IndexSelection.vue?vue&type=script&lang=js"
import style0 from "./IndexSelection.vue?vue&type=style&index=0&id=775b2bdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775b2bdc",
  null
  
)

export default component.exports